// ENV value productions or development is set in package.json.
// Udpate version in this file before deploymet tuo make sure that js and css files are reloaded.
// --dist-dir setting for parcel build and watch in package.json
module.exports = {
    version: 129,
    environment: process.env.ENV,
    development: {
        client : "http://localhost:3000",
        server : "http://localhost:8080",
        console : "http://localhost:3000",
        rootPath : "",
        staticFilesRootPath : ""
    },
    production: {
        client : "",
        server : "https://api.youpret.com",
        console : "https://console.youpret.com",
        rootPath : "",
        staticFilesRootPath : "",
    },
    browserSyncStartPath : "/fi/"
};